module.exports = __webpack_public_path__ + "UX34.png?6ec0b46e80b98d10444f6bc5bb396f6a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UX34.png
// module id = 84
// module chunks = 0